import getCharts from '../getCharts'
import { ManageUser } from '../../constants/api.config'

export default async function RegisterUser( username, password,email,role,mode="insert",phoneNumber="",extraData="",id="") {
  try {
    const payload = {id, username, password: password || null, email, role, mode, phoneNumber, extraData }
    const res = await getCharts(ManageUser, payload)
    return res.data
  } catch (error) {
    return error
  }
}
